import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import moment from 'moment'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down'

import financeActions from 'actions/financeActions'

import { properties } from 'selectors/entities'
import { reportProperty } from 'selectors/reports'


let select = (state, props) => ({
	properties: properties(state)
  , property: reportProperty(state)
})

export class PropertySelect extends Component {
	state = { isOpen: false }
	toggleMenu = () => {
		this.setState({
			isOpen: !this.state.isOpen
		})
	}
	render () {
		let {props} = this
		return (
			<div
				className="property-holder"
				style={{display: "flex"}}
			>
				<div
					className="value"
					onClick={this.toggleMenu}
					style={{
						cursor: "pointer"
					}}
				>
					{props.property || "All properties"}
				</div>
				<IconMenu
					open={this.state.isOpen}
					onRequestChange={this.toggleMenu}
					iconButtonElement={
						<IconButton style={{paddingLeft: '0px', verticalAlign: 'middle', marginTop: '-3px'}}>
							<ArrowDropDown	color='#FFF'/>
						</IconButton>
					}
					onItemTouchTap={(evt, item) => {
						props.SET_PROPERTY(item.key)
					}}
				>
					<MenuItem
						key={"total"}
						value={"All properties"}
						primaryText={"All properties"}
					/>
					{R.values(R.map(
						property => (
							<MenuItem key={property._id} value={property.alias} primaryText={property.alias}/>)
						)(props.properties))
					}
				</IconMenu>
			</div>
		)
	}
}
export default connect(select, financeActions)(PropertySelect)



// WEBPACK FOOTER //
// ./src/routes/landlord/finances/PropertySelect.js